/**
 * Theme Copa Energia
 *
 * Tema personalizado para Copa Energia.
 * Cores principais:
 * - Verde escuro: #243834
 * - Laranja: #ff8a31
 *
 * @since 2025-12-17
 * @epic INIT-0045-03
 */

import type { Theme } from '../types';

export const copaEnergiaTheme: Theme = {
  name: 'Copa Energia',
  id: 'copaenergia',

  background: {
    color: '#f3f4f6',
    colorDark: '#111827',
    image: '',
    imageDark: '',
    loginImage: '',
    loginImageDark: '',
    loginColor: '',
    loginColorDark: '',
  },

  colors: {
    link: '#243834',
    linkHover: '#1a2927',
    dialog: '#243834',
    emailLink: '#fff',
    emailLinkDark: '',
    h1: '#243834',
    h2: '#243834',
    footerText: '#6b7280',
    footerTextDark: '',
    footerBackground: '#ffffff',
    footerBackgroundDark: '',
    footerBorder: '#e5e7eb',
    footerBorderDark: '',
    sidebarBackground: '#243834',
    sidebarBackgroundDark: '#3e504c',  // verde Copa 15% clareado — aparece sobre bg #171717
    topbarBackground: '#243834',
    topbarBackgroundDark: '#3e504c',   // verde Copa 15% clareado — não escurecer (já é escuro)
    topbarText: '#ffffff',
    topbarTextDark: '#f0f0f0',         // off-white para melhor renderização em dark
    topbarBorder: '#1a2927',
    topbarBorderDark: '#1a2927',       // borda original mantida — contraste adequado sobre verde dark
  },

  blocks: {
    // Cores alternadas para blocos do dashboard
    // block1: Verde escuro Copa - indices pares (0, 2, 4...)
    // block2: Laranja Copa - indices impares (1, 3, 5...)
    block1: {
      background: '#243834',
      text: '#fff',
    },
    block2: {
      background: '#ff8a31',
      text: '#fff',
    },
  },

  buttons: {
    danger: {
      text: '#fff',
      background: '#d43f3a',
      backgroundHover: '#ba3732',
    },
    info: {
      text: '#fff',
      background: '#46b8da',
      backgroundHover: '#3da1bf',
    },
    secondary: {
      text: '#fff',
      background: '#6b7280',
      backgroundHover: '#4b5563',
    },
    success: {
      text: '#fff',
      background: '#62c462',
      backgroundHover: '#55ab55',
    },
    warning: {
      text: '#fff',
      background: '#f0ad4e',
      backgroundHover: '#d69a45',
    },
    primary: {
      text: '#fff',
      background: '#ff8a31',
      backgroundHover: '#e67a28',
    },
  },

  menus: {
    main: {
      background: '#243834',
      text: '#e5ebe9',
      border: 'rgba(255,255,255,0.12)',
      activeBackground: '#ff8a31',
      activeText: '#fff',
      hoverBackground: 'rgba(255,255,255,0.1)',
      hoverText: '#ffffff',
    },
    submenu: {
      background: '#1a2927',
      text: '#c8d8d4',
      border: 'rgba(255,255,255,0.08)',
      activeBackground: '#ff8a31',
      activeText: '#fff',
      hoverBackground: 'rgba(255,255,255,0.08)',
      hoverText: '#ffffff',
    },
  },

  logos: {
    principal: '',
    principalDark: '',
    menu: '',
    menuDark: '',
    campanha: '',
    campanhaDark: '',
    loading: '',
    loadingDark: '',
  },

  icons: {
    appleTouch60: '',
    appleTouch76: '',
    appleTouch120: '',
    appleTouch152: '',
    favicon: '',
    faviconDark: '',
  },
};

export default copaEnergiaTheme;
